import React from 'react';
import { Button, MobileStepper, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import { FormattedMessage } from 'react-intl';

import { sx } from '../../../../../../DesignSystem/LinearProgress/LinearProgress';

const ProgressBar = React.forwardRef(({ total, count, onClickNext, ...props }: any, ref: any) => {
  const theme = useTheme();

  return (
    <MobileStepper
      variant="progress"
      position="static"
      steps={total + 1} // the step 1 starts with no visual ui clue so adding a step to cheat
      LinearProgressProps={{
        variant: 'determinate',
        color: 'secondary',
        sx: {
          width: { md: '75%' },
          ...sx(),
        },
        ref,
        ...props,
      }}
      activeStep={count}
      backButton={
        <Typography {...props}>
          {count}/{total}
        </Typography>
      }
      nextButton={
        <Button
          size="small"
          color="primary"
          onClick={onClickNext}
          sx={{ px: 1.5 }}
          endIcon={theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
        >
          <FormattedMessage id="NEXT" />
        </Button>
      }
    />
  );
});

ProgressBar.displayName = 'ProgressBar';

export default ProgressBar;
